import { APIGatewayService } from "@core/gateway/APIGateway.service";
import { AppInjector } from "@core/injector/injector.module";
import { AppConfigService } from '@configuration/app.config.service';
import { IBaseModuleComponent } from '../component/IBaseComponent';
import { Inject, InjectionToken } from "@angular/core"; 

export const EMPTY_STRING_TOKEN = new InjectionToken<string>('name');

export abstract class BaseEndpoint implements IBaseModuleComponent {
    ControllerName: string;

    ModuleName: string = AppInjector.get(AppConfigService).getModuleNameByInstance(this);

    constructor(
        @Inject(EMPTY_STRING_TOKEN) ControllerName: string,
        protected api: APIGatewayService) {
        this.ControllerName = this.ModuleName ? `${this.ModuleName}/${ControllerName}` : ControllerName;
    }

    GetControllerURL(): string {
        return this.api.GetAPIURL() + this.ControllerName;
    }

}